// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMPhoto.tsx — PropelMapper photo treatment wrapper.
//
// Drops a photo into one of the brand's standard treatments so imagery stays
// on-brand across the site:
//   natural  — honest editorial (subtle saturation/contrast)
//   clean    — 6px white frame + mint hairline + soft shadow (mirrors cards)
//   grade    — dark-green color blend that unifies mixed lighting to the palette
//              (intensity via `grade` 0–100)
//   overlay  — bottom dark-green gradient so caption text sits on the photo
//   sticker  — white border + slight tilt + optional brand badge (ACCENT ONLY)
//
// Rebuilt on --pm-* tokens (grade = --pm-primary, scrims = --pm-primary-dark via
// color-mix) so it themes with the system — no hardcoded greens. With no `src`
// it renders a labeled placeholder so layouts can be built before photos exist.

const PMPHOTO_CSS = `
.pmphoto{box-sizing:border-box;position:relative;overflow:hidden;border-radius:14px;background:var(--pm-surface-variant);margin:0;display:block}
.pmphoto-media{position:absolute;inset:0;overflow:hidden}
.pmphoto-media img,.pmphoto-ph{width:100%;height:100%;object-fit:cover;display:block}
.pmphoto-ph{display:grid;place-items:center;background:linear-gradient(135deg,#caa97f 0%,#a7a06f 45%,#6b8e74 100%)}
.pmphoto-ph span{font-family:var(--pm-font-mono,ui-monospace,monospace);font-size:11px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:rgba(255,255,255,.92);text-shadow:0 1px 3px rgba(0,0,0,.35)}
.pmphoto--natural .pmphoto-media img{filter:saturate(1.04) contrast(1.02)}
.pmphoto--clean{border:6px solid #fff;outline:1px solid color-mix(in srgb,var(--pm-primary-light) 45%,transparent);box-shadow:0 10px 25px color-mix(in srgb,var(--pm-primary) 16%,transparent),0 4px 8px color-mix(in srgb,var(--pm-primary) 10%,transparent)}
.pmphoto--grade .pmphoto-media img{filter:saturate(calc(1 + var(--pmphoto-grade,.55)/1.8))}
.pmphoto--grade::after{content:"";position:absolute;inset:0;background:var(--pm-primary);mix-blend-mode:color;opacity:var(--pmphoto-grade,.55);pointer-events:none;z-index:1}
.pmphoto--overlay::after{content:"";position:absolute;inset:0;z-index:1;pointer-events:none;background:linear-gradient(0deg, color-mix(in srgb,var(--pm-primary-dark) 86%,transparent) 0%, color-mix(in srgb,var(--pm-primary-dark) 30%,transparent) 45%, transparent 75%)}
.pmphoto--sticker{border:9px solid #fff;border-radius:18px;transform:rotate(-2deg);box-shadow:0 14px 30px color-mix(in srgb,var(--pm-primary) 20%,transparent)}
.pmphoto-cap{position:absolute;z-index:2;left:16px;right:16px;bottom:14px}
.pmphoto-cap-eyebrow{color:color-mix(in srgb,var(--pm-primary-light) 55%,#fff);font-size:11px;font-weight:700;letter-spacing:.12em;text-transform:uppercase}
.pmphoto-cap-title{color:#fff;font-size:19px;font-weight:700;line-height:1.15;margin-top:3px;font-family:var(--pm-font-sans)}
.pmphoto-badge{position:absolute;right:9px;bottom:9px;width:42px;height:42px;border-radius:50%;background:#fff;box-shadow:0 4px 10px rgba(0,0,0,.18);display:grid;place-items:center;z-index:2}
.pmphoto-badge img,.pmphoto-badge svg{width:24px;height:24px;object-fit:contain}
`;
function pmphotoEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmphoto-css")) return;
  const s = document.createElement("style"); s.id = "pmphoto-css"; s.textContent = PMPHOTO_CSS;
  document.head.appendChild(s);
}

export function PMPhoto({
  src,
  alt = "",
  treatment = "natural",
  grade = 55,
  ratio = "4 / 3",
  eyebrow,
  title,
  badge,
  placeholder = "Field photo",
  className = "",
  style = {},
  ...rest
}) {
  pmphotoEnsureCSS();
  const vars = treatment === "grade" ? { "--pmphoto-grade": Math.max(0, Math.min(100, grade)) / 100 } : {};
  return (
    <figure
      className={"pmphoto pmphoto--" + treatment + (className ? " " + className : "")}
      style={{ aspectRatio: ratio, ...vars, ...style }}
      {...rest}
    >
      <div className="pmphoto-media">
        {src ? <img src={src} alt={alt} /> : <div className="pmphoto-ph"><span>{placeholder}</span></div>}
      </div>
      {treatment === "overlay" && (eyebrow || title) ? (
        <figcaption className="pmphoto-cap">
          {eyebrow ? <div className="pmphoto-cap-eyebrow">{eyebrow}</div> : null}
          {title ? <div className="pmphoto-cap-title">{title}</div> : null}
        </figcaption>
      ) : null}
      {treatment === "sticker" && badge ? <span className="pmphoto-badge">{badge}</span> : null}
    </figure>
  );
}
